import { useQuery } from "@apollo/client";
import { useTranslation } from "react-i18next";

import GET_COS_PDF from "../../../../graphql/queries/ola/getCosPdf";
import IconButton from "../../../../components/IconButton";

const ExportCosPdf = ({ omobilityId }) => {
  const { t } = useTranslation();

  const { data } = useQuery(GET_COS_PDF, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
    variables: { omobilityID: omobilityId },
    skip: !omobilityId,
  });

  const base64Str = data?.cosPdf;

  if (base64Str) {
    const byteCharacters = atob(base64Str);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const file = new Blob([byteArray], { type: "application/pdf;base64" });
    const fileURL = URL.createObjectURL(file);

    return (
      <a href={fileURL} target="_blank" rel="noreferrer">
        <IconButton
          variant={"download"}
          disabled={false}
          title={"Download PDF"}
        />
      </a>
    );
  }

  return (
    <IconButton variant={"download"} disabled={true} title={""} />
  );
};

export default ExportCosPdf;
